import css_0d8zx8z9iuk5 from './css/Overlay.css';
import Div from './Div.js';
import Title from './Title.js';
import Detail from './Detail.js';
import CallToAction from './CallToAction.js';
import Poster from './Poster.js';

const css = css_0d8zx8z9iuk5;

export default class Overlay extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.posterContainer = new PosterContainer(this);
		this.title = new Title(this);
		this.detail = new Detail(this);
		this.callToAction = new CallToAction(this);
	}

	get cssText()
	{
		return css;
	}

	set value(value)
	{
		this.posterContainer.poster.value = value['thumbnailUrl'];
		this.title.value = value['configuration']['title'];
		this.detail.value = value['S_shortSummary'];
		this.callToAction.time.value = value['configuration']['duration'];
	}
}

class PosterContainer extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.poster = new Poster(this);
		this.playButton = new PlayButton(this);
	}
}

class PlayButton extends Div {}